import type { AdminConfigItemDto } from '@carcheck/shared';

import { asRawRecords, isRawRecord } from './rawRecord';

/**
 * AUT-542 — which `/config` keys open a form instead of the inline editor.
 * A stored value the form cannot read (not a list of records / not a
 * record) falls back to the JSON editor rather than a broken form.
 */

export const DEAL_STAGES_KEY = 'deals.stages';
export const FX_KEY = 'specialists.fx';

export type ConfigFormKind = 'stages' | 'fx';

export const configFormKind = (item: AdminConfigItemDto): ConfigFormKind | null => {
  if (!item.present) return null;
  if (item.key === DEAL_STAGES_KEY && asRawRecords(item.value) !== null) return 'stages';
  if (item.key === FX_KEY && (item.value === null || isRawRecord(item.value))) return 'fx';
  return null;
};
